import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDraft(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14.2246 21.751C13.508 21.9139 12.7633 22 12 22C11.2367 22 10.492 21.9139 9.77539 21.751L10.2188 19.7979C10.7918 19.9282 11.3875 20 12 20C12.6122 20 13.2075 19.9281 13.7803 19.7979L14.2246 21.751Z"
        fill="currentColor"
      />
      <path
        d="M5.22656 16.2549C5.86632 17.2712 6.72795 18.1325 7.74414 18.7725L6.67773 20.4678C5.4083 19.6684 4.33157 18.5917 3.53223 17.3223L5.22656 16.2549Z"
        fill="currentColor"
      />
      <path
        d="M20.4678 17.3223C19.6684 18.5917 18.5917 19.6684 17.3223 20.4678L16.2549 18.7725C17.2712 18.1326 18.1326 17.2712 18.7725 16.2549L20.4678 17.3223Z"
        fill="currentColor"
      />
      <path
        d="M4.20117 10.2188C4.07085 10.7917 4 11.3876 4 12C4 12.6121 4.07099 13.2076 4.20117 13.7803L2.24902 14.2246C2.08613 13.508 2 12.7633 2 12C2 11.2367 2.08613 10.492 2.24902 9.77539L4.20117 10.2188Z"
        fill="currentColor"
      />
      <path
        d="M21.751 9.77539C21.9139 10.492 22 11.2367 22 12C22 12.7633 21.9139 13.508 21.751 14.2246L19.7979 13.7803C19.9281 13.2075 20 12.6122 20 12C20 11.3875 19.9282 10.7918 19.7979 10.2188L21.751 9.77539Z"
        fill="currentColor"
      />
      <path
        d="M7.74414 5.22656C6.72799 5.86637 5.86637 6.72799 5.22656 7.74414L3.53223 6.67773C4.33157 5.4083 5.4083 4.33157 6.67773 3.53223L7.74414 5.22656Z"
        fill="currentColor"
      />
      <path
        d="M17.3223 3.53223C18.5917 4.33157 19.6684 5.4083 20.4678 6.67773L18.7725 7.74414C18.1325 6.72795 17.2712 5.86632 16.2549 5.22656L17.3223 3.53223Z"
        fill="currentColor"
      />
      <path
        d="M12 2C12.7633 2 13.508 2.08613 14.2246 2.24902L13.7803 4.20117C13.2076 4.07099 12.6121 4 12 4C11.3876 4 10.7917 4.07085 10.2188 4.20117L9.77539 2.24902C10.492 2.08613 11.2367 2 12 2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
